<template>
    <div>
        <input-validate
            type="text"
            title="Name"
            name="name"
            v-model="name"
            placeholder="Enter your name"
            v-validate="'required'"
            data-vv-value-path="innerValue"
            data-vv-validate-on="blur"
            :error="errors.first('name')"
            :is-title-latent="true"
        ></input-validate>
        <input-validate
            type="text"
            title="UPI"
            name="upi"
            v-model="upi"
            placeholder="Enter your upi"
            v-validate="'required|upi'"
            data-vv-value-path="innerValue"
            data-vv-validate-on="blur"
            :error="errors.first('upi')"
            :is-title-latent="true"
        ></input-validate>
        <md-button style="margin-top: 0.5rem;" type="primary" :loading="loading" :disabled="loading" @click="submit_payment">Confirm</md-button>
    </div>
</template>

<script>
import { Validator } from "vee-validate";
import inputValidate from "@/components/input-validate";
import { postpayment } from '@/request/api'


Validator.extend("upi", {
    getMessage: field => `${field} value do not meet right format`,
    validate: value => /^[\w.-]+@[\w.-]+$/.test(value)
});

export default {
    name: 'paymentupiform',
    components: {
        inputValidate
    },
    props: {
        bank: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            loading: false,
            name: "",
            upi: "",
            id: ""
        }
    },
    created() {
        if(this.bank !== {}) {
            this.id = this.bank.id;
            this.name = this.bank.name;
            this.upi = this.bank.upi;
        }
    },
    methods: {
        submit_payment() {
            let that = this;
            that.loading = true;
            const success = this.$validator.validateAll().then(res=>{
                if(res) {
                    let formdata = {
                        method: 'upi',
                        name: that.name,
                        upi: that.upi
                    }
                    if(this.id !== "") {
                        formdata.id = this.id;
                    }
                    postpayment(formdata).then(res=>{
                        that.loading = false;
                        if(res.code === 200) {
                            that.$toast.succeed("Successfully");
                            that.$router.push('/paymentmethods');
                        } else {
                            that.$toast.failed(res.errmsg);
                        }
                    }).catch(error=> {
                        console.log(error);
                        that.loading = false;
                        that.$toast.failed("fail");
                    })
                } else {
                    that.loading = false;
                    return
                }
            })
        },
    }
}

</script>
<style scoped>
.upi-tips {
    margin-top: 0.3rem;
    color: #46ac2a;
    font-size: 0.20rem;
}
</style>



// WEBPACK FOOTER //
// src/views/my/forms/paymentupiform.vue